import { useMutation } from 'react-query'
import { toast } from 'react-toastify'
import { QueryNames } from 'Hooks/api/queryNames'
import { AppNotification } from 'Utils/types/appNotification'
import { refreshTransactions } from 'Services/JOONAdmin/joonAdminUsersService'

export const useRefreshTransactionsQuery = () => {
  return useMutation([QueryNames.RefreshTransactions], refreshTransactions, {
    onSuccess: (response) => {
      if (response.success) {
        toast.success(response.message || AppNotification.RefreshTransactionsSuccess)
      } else {
        toast.error(`${AppNotification.RefreshTransactionsFailure} ${response.message}`)
      }
    },
    onError: () => {
      toast.error(AppNotification.RefreshTransactionsFailure)
    }
  })
}
